import { render, staticRenderFns } from "./VersionUpdateModal.Style#Drawer.vue?vue&type=template&id=ea8c8164&scoped=true"
import script from "./VersionUpdateModal.Style#Drawer.vue?vue&type=script&lang=js"
export * from "./VersionUpdateModal.Style#Drawer.vue?vue&type=script&lang=js"
import style0 from "./VersionUpdateModal.Style#Drawer.vue?vue&type=style&index=0&id=ea8c8164&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8c8164",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea8c8164')) {
      api.createRecord('ea8c8164', component.options)
    } else {
      api.reload('ea8c8164', component.options)
    }
    module.hot.accept("./VersionUpdateModal.Style#Drawer.vue?vue&type=template&id=ea8c8164&scoped=true", function () {
      api.rerender('ea8c8164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/versionUpdate/modules/VersionUpdateModal.Style#Drawer.vue"
export default component.exports